import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isMobileOnly } from 'react-device-detect'

const bc = 'hovered-icon'

class HoveredIcon extends Component {
  state = {
    hovered: false,
  }

  render() {
    const { defaultIcon, activeIcon, active, label, iconClass, labelClass } = this.props
    return (
      <span
        className={bc}
        onMouseEnter={e => {
          this.setState({ hovered: true })
          if (isMobileOnly) {
            const ev = new CustomEvent('click', { bubbles: true })
            e.target.dispatchEvent(ev)
          }
        }}
        onMouseLeave={() => this.setState({ hovered: false })}
      >
        <span className={iconClass}>
          {active || this.state.hovered ? React.createElement(activeIcon) : React.createElement(defaultIcon)}
        </span>
        {label && <span className={labelClass}>{label}</span>}
      </span>
    )
  }
}

HoveredIcon.propTypes = {
  defaultIcon: PropTypes.func.isRequired,
  activeIcon: PropTypes.func.isRequired,
  label: PropTypes.string,
  active: PropTypes.bool,
  iconClass: PropTypes.string,
  labelClass: PropTypes.string,
}

export default HoveredIcon
